"use client";

import * as React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { Button } from "../components/ui/button";
import { TeamsCombobox, TeamsProvider } from "../components/ui/TeamsCombobox";

export function TeamsComboboxExample() {
  const [selectedTeams, setSelectedTeams] = React.useState<string[]>([]);
  
  // Example of programmatically setting selected teams
  const setExampleTeams = () => {
    // These IDs should match actual team IDs from your data
    setSelectedTeams(['team-1', 'team-2']);
  };
  
  // Clear all selected teams
  const clearAll = () => {
    setSelectedTeams([]);
  };
  
  // Handle when a team is selected
  const handleTeamSelect = (teamId: string) => {
    console.log(`Team selected: ${teamId}`);
  };
  
  // Handle when a team is deselected
  const handleTeamDeselect = (teamId: string) => {
    console.log(`Team deselected: ${teamId}`);
  };
  
  // Example of custom teams data (optional)
  const customTeams = [
    { id: 'custom-1', name: 'Custom Team 1' },
    { id: 'custom-2', name: 'Custom Team 2' },
  ];
  
  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>Teams Combobox</CardTitle>
          <CardDescription>
            A combobox component for selecting multiple teams.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="space-y-2">
            <h3 className="text-sm font-medium">Basic Usage</h3>
            <TeamsCombobox
              selected={selectedTeams}
              setSelected={setSelectedTeams}
              onTeamSelect={handleTeamSelect}
              onTeamDeselect={handleTeamDeselect}
              className="w-full"
            />
          </div>
          
          <div className="space-y-2">
            <h3 className="text-sm font-medium">With Custom Teams</h3>
            <TeamsCombobox
              selected={selectedTeams}
              setSelected={setSelectedTeams}
              teams={customTeams}
              className="w-full"
            />
          </div>
          
          <div className="flex space-x-2 pt-2">
            <Button variant="outline" size="sm" onClick={setExampleTeams}>
              Set Example Teams
            </Button>
            <Button variant="outline" size="sm" onClick={clearAll}>
              Clear All
            </Button>
          </div>
          
          <div className="pt-4">
            <h3 className="text-sm font-medium mb-2">Selected Teams:</h3>
            <div className="space-y-2">
              {selectedTeams.length > 0 ? (
                <div className="flex flex-wrap gap-2">
                  {selectedTeams.map((teamId) => (
                    <Badge key={teamId} variant="secondary">
                      {teamId}
                    </Badge>
                  ))}
                </div>
              ) : (
                <p className="text-sm text-muted-foreground">No teams selected</p>
              )}
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

// Wrap the example with the TeamsProvider for demonstration purposes
export default function TeamsComboboxExampleWrapper() {
  return (
    <TeamsProvider>
      <TeamsComboboxExample />
    </TeamsProvider>
  );
}
